import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	issuePickerCreatePlaceholder: {
		id: 'polaris-lib-issue-select.option.issue-picker-create-placeholder',
		defaultMessage: 'Create a new idea, "{label}"',
		description: 'Placeholder text in issue picker create component.',
	},
});
